import { render, staticRenderFns } from "./shippingOptionsTable.vue?vue&type=template&id=71716a87&"
import script from "./shippingOptionsTable.vue?vue&type=script&lang=js&"
export * from "./shippingOptionsTable.vue?vue&type=script&lang=js&"
import style0 from "./shippingOptionsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports